import PropTypes from "prop-types";
import UserProductRatingsContainer from "../user_product_ratings/user-product-ratings-container";
import PDPPrice from "./pdp-price";
import { analytics, flagsAndExperimentNames } from "rtr-constants";
import { useSelector } from "react-redux";
import { withOnLoadFlagsAndExperiments } from "components/source/hoc/with-flags-and-experiments.jsx";
import PromoExclusion from "./promo-exclusion";

const propTypes = {
  analyticsLoggingContext: PropTypes.object,
  annotationSuffix: PropTypes.string,
  isHeartEducationTooltipTriggered: PropTypes.bool,
  isMembershipUpsellView: PropTypes.bool,
  isRentable: PropTypes.bool,
  isRetailOnly: PropTypes.bool,
  membershipPricing: PropTypes.array,
  product: PropTypes.object.isRequired,
  rentalText: PropTypes.string,
  showPurchasePrice: PropTypes.bool,
};

function PDPHeader(props) {
  const { product } = props;
  const atbTabExp = useSelector(state => state.flagsAndExperiments?.[flagsAndExperimentNames.RSV_1494_ATB_TABS]);
  const promoExclusionFlag = useSelector(
    state => state.flagsAndExperiments?.[flagsAndExperimentNames.CATALOG_SERVICES_SHOW_PROMO_EXCLUSION]
  );
  const staticProduct = useSelector(state => state.staticProduct);

  if (!product) return null;

  const { designer = {}, displayName } = product;

  const renderHeart = () => {
    return (
      <div className="product-rating-container__wrapper -mr-3">
        <UserProductRatingsContainer
          customHeartLoggingOptions={props.analyticsLoggingContext}
          isHeartEducationTooltipTriggered={props.isHeartEducationTooltipTriggered}
          product={product}
          location={analytics.ACTION_LOCATIONS.PDP}
        />
      </div>
    );
  };

  return (
    <div className="pdp-header">
      <div className="flex justify-between items-center">
        <h1 className="font-sans text-md text-darkerGray pb-2" itemProp="name" aria-label="Product Name">
          {displayName}
        </h1>
        <div className="flex items-center">{renderHeart()}</div>
      </div>
      <h2 className="font-sans text-h4 underline pb-2">
        <a href={"/designers/" + designer.id + "?source=pdp"}>{designer.displayName}</a>
      </h2>

      <PDPPrice
        annotationSuffix={props.annotationSuffix}
        isMembershipUpsellView={props.isMembershipUpsellView}
        isRentable={props.isRentable}
        isRetailOnly={props.isRetailOnly || atbTabExp}
        membershipPricing={props.membershipPricing}
        product={props.product}
        rentalText={props.rentalText}
        showPurchasePrice={props.showPurchasePrice}
      />
      {promoExclusionFlag && staticProduct?.merchandisingCategory === "Clearance" && (
        <PromoExclusion shouldExclude={staticProduct && staticProduct?.styleoutYear === "2025"} />
      )}
    </div>
  );
}

PDPHeader.propTypes = propTypes;

export default withOnLoadFlagsAndExperiments(flagsAndExperimentNames.RSV_1494_ATB_TABS)(PDPHeader);
